module.exports = __webpack_public_path__ + "img/img05_text_m.63372462.png";